/**
 * Market-aware money formatting for client-rendered prices.
 *
 * snippets/format-money.liquid is the source of truth for how a price looks in
 * each market. It also emits those rules as JSON into
 * FoxTheme.settings.moneyFormatConfig, and this file replays them here so a price
 * written by JavaScript (variant switch, cart drawer totals, bundle builder,
 * sticky add-to-cart bar) is identical to the same price rendered by Liquid.
 *
 * It replaces FoxTheme.Currency.formatMoney from theme.js rather than editing it,
 * for the same reason as min-purchase-qty.js: theme.js is vendor code that a Hyper
 * update overwrites. The signature is unchanged, so every existing caller keeps
 * working; the `format` argument is ignored because the market config already
 * carries everything the old format string encoded.
 *
 * The vendor implementation cannot express our markets anyway — it has no branch
 * for a space thousands separator with decimals, which is eight of our markets
 * (NO, SE, FI, FR, PL, CZ, SK, LT), and would have rendered those prices as a
 * bare currency symbol with no digits at all.
 */
(function () {
  var NBSP = ' ';

  var FALLBACK = {
    symbol: '',
    code: '',
    before: false,
    gap: true,
    thousands: '.',
    decimal: ',',
    decimals: 2,
    showCode: false,
  };

  function config() {
    var settings = (window.FoxTheme && window.FoxTheme.settings) || {};
    return settings.moneyFormatConfig || FALLBACK;
  }

  function formatMoney(cents) {
    var rules = config();

    if (typeof cents === 'string') {
      // Callers pass anything from '1299' to '1.299,95' to '£1,299.95'.
      cents = cents.replace(/[^0-9-]/g, '');
    }

    var value = Number(cents);
    if (!isFinite(value)) value = 0;

    var sign = value < 0 ? '-' : '';
    value = Math.abs(value);

    var parts = (value / 100).toFixed(rules.decimals).split('.');
    var number = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + rules.thousands);
    if (parts[1]) number += rules.decimal + parts[1];

    var gap = rules.gap ? NBSP : '';
    var money = rules.before ? rules.symbol + gap + number : number + gap + rules.symbol;

    if (rules.showCode && rules.code) money += NBSP + rules.code;

    return sign + money;
  }

  function install() {
    if (!window.FoxTheme || !window.FoxTheme.Currency) return false;
    window.FoxTheme.Currency.formatMoney = formatMoney;
    return true;
  }

  // theme.js is deferred and loaded first, so FoxTheme.Currency already exists.
  // The listener is a safety net in case the load order ever changes.
  if (!install()) {
    document.addEventListener('DOMContentLoaded', install);
  }
})();
